import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';
import { useCaseBuilderContext } from '../../context/CaseBuilderContext';

const MobileCarouselDots = styled.div`
	display: none;

	${EmotionBreakpoint('mobile')} {
		display: flex;
		justify-content: center;
		gap: 8px;
		padding: 0;
	}
	${EmotionBreakpoint('tablet')} {
		display: flex;
		justify-content: center;
		gap: 8px;
		padding: 16px 0;
	}
`;

const CarouselDotIndicator = styled.button`
	width: 8px;
	height: 8px;
	border-radius: 50%;
	border: none;
	background: ${(props) => (props.active ? '#B1927B' : '#E5E5E5')};
	cursor: pointer;
	padding: 0;
	transition: background 0.3s ease;

	&:hover {
		background: ${(props) => (props.active ? '#B1927B' : '#BCBCBC')};
	}

	.law & {
		background: ${(props) => (props.active ? '#B1927B' : '#E5E5E5')};
	}
	.fox & {
		background: ${(props) => (props.active ? '#222' : '#E5E5E5')};
	}
	.wsj & {
		background: ${(props) => (props.active ? '#2B2A2F' : '#E5E5E5')};
	}
	.npr & {
		background: ${(props) => (props.active ? '#2B2A2F' : '#E5E5E5')};
	}
	.osw & {
		background: ${(props) => (props.active ? '#2B2A2F' : '#E5E5E5')};
	}
`;

const CarouselDots = () => {
	const { wineSlots, activeBottleIndex, handleCarouselDotClick } =
		useCaseBuilderContext();

	return (
		<MobileCarouselDots>
			{wineSlots.slice(0, 12).map((_, index) => (
				<CarouselDotIndicator
					key={`mobile-dot-${index}`}
					active={index === activeBottleIndex}
					onClick={() => handleCarouselDotClick(index)}
				/>
			))}
		</MobileCarouselDots>
	);
};

export default CarouselDots;
